import { ComboboxTranslations } from './combobox-translations.interface';

/**
 * German translations for the Combobox directive
 * Complete translation set for German language
 */
export const GERMAN_COMBOBOX_TRANSLATIONS: ComboboxTranslations = {
  ariaLabel: 'Vorschläge',
  noResultsText: 'Keine Ergebnisse gefunden'
};
